var map = {
	"./en/messages.json": [
		33994,
		3994
	],
	"./pt-br/messages.json": [
		2203,
		2203
	],
	"./zh/messages.json": [
		44957,
		4957
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 7566;
module.exports = webpackAsyncContext;